import { type Enum } from '@webapp/infrastructure/types/Enum'

// Lifecycle status of a travel request (numeric codes from /api/v2 + /api/travel payloads)
export const TravelStatuses = {
  PENDING: 0,
  APPROVED: 1,
  DENIED: 2,
} as const

export type TravelStatusEnum = Enum<typeof TravelStatuses>
